
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs"
import { WorkflowManagement } from "@/components/settings/WorkflowManagement"
import { DepartmentsConfiguration } from "@/components/settings/DepartmentsConfiguration"
import { CompanySettings } from "@/components/settings/CompanySettings"
import { ProductSettings } from "@/components/settings/ProductSettings"
import { Settings as SettingsIcon, Workflow, Building2, Tags } from "lucide-react"

const Settings = () => {
  return (
    <div className="container mx-auto py-6">
      <div className="mb-6">
        <h1 className="text-3xl font-bold">系統設定</h1>
        <p className="text-muted-foreground">
          管理工作流程、部門配置和系統設定
        </p>
      </div>

      <Tabs defaultValue="workflow-management" className="w-full">
        <TabsList className="grid w-full grid-cols-4">
          <TabsTrigger value="workflow-management" className="flex items-center gap-2">
            <Workflow className="h-4 w-4" />
            工作流程管理
          </TabsTrigger>
          <TabsTrigger value="departments" className="flex items-center gap-2">
            <Building2 className="h-4 w-4" />
            部門配置
          </TabsTrigger>
          <TabsTrigger value="product-attributes" className="flex items-center gap-2">
            <Tags className="h-4 w-4" />
            產品設定
          </TabsTrigger>
          <TabsTrigger value="company" className="flex items-center gap-2">
            <SettingsIcon className="h-4 w-4" />
            公司設定
          </TabsTrigger>
        </TabsList>

        <TabsContent value="workflow-management" className="mt-6">
          <WorkflowManagement />
        </TabsContent>

        <TabsContent value="departments" className="mt-6">
          <DepartmentsConfiguration />
        </TabsContent>

        <TabsContent value="product-attributes" className="mt-6">
          <ProductSettings />
        </TabsContent>

        <TabsContent value="company" className="mt-6">
          <CompanySettings />
        </TabsContent>
      </Tabs>
    </div>
  )
}

export default Settings
